import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './dictionary/en.json';

export default function i18n_Initialize() {
  i18n.use(initReactI18next).init({
    resources: {
      en,
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
}

export const i18next = i18n;
